import { c as _c } from "react/compiler-runtime";
import type { AddPrCommentType } from '@/components/inbox/prs/types/pr-comment-input';
import { useHotkeys } from 'react-hotkeys-hook';
import { usePrCommentInputStore } from './pr-comment-input-store';

/**
 * Helper function to check if user is clicking the line that already has an active comment input
 */
const isClickingActivePrComment = (activePrCommentInput: AddPrCommentType | null, newLocation: AddPrCommentType) => {
  return activePrCommentInput?.filename === newLocation.filename && activePrCommentInput?.lineNumber === newLocation.lineNumber && activePrCommentInput?.side === newLocation.side && activePrCommentInput?.subject_type === newLocation.subject_type;
};

/**
 * Manages PR comment input state, allowing only one active comment input at a time.
 * Used for both manual inline comments and AI-suggested comments.
 */
export function usePrCommentInput() {
  const $ = _c(13);
  const {
    activePrCommentInput,
    setActivePrCommentInput
  } = usePrCommentInputStore();
  let t0;
  if ($[0] !== activePrCommentInput || $[1] !== setActivePrCommentInput) {
    t0 = args => {
      if (!args) {
        setActivePrCommentInput(null);
        return;
      }
      isClickingActivePrComment(activePrCommentInput, args) ? setActivePrCommentInput(null) : setActivePrCommentInput(args);
    };
    $[0] = activePrCommentInput;
    $[1] = setActivePrCommentInput;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const togglePrCommentInput = t0;
  let t1;
  if ($[3] !== setActivePrCommentInput) {
    t1 = () => {
      setActivePrCommentInput(null);
    };
    $[3] = setActivePrCommentInput;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const closePrCommentInput = t1;
  let t2;
  if ($[5] !== closePrCommentInput) {
    t2 = event => {
      event.preventDefault();
      event.stopPropagation();
      closePrCommentInput();
    };
    $[5] = closePrCommentInput;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = Boolean(activePrCommentInput);
  let t4;
  if ($[7] !== t3) {
    t4 = {
      enableOnFormTags: true,
      enabled: t3
    };
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  useHotkeys("esc", t2, t4);
  let t5;
  if ($[9] !== activePrCommentInput || $[10] !== closePrCommentInput || $[11] !== togglePrCommentInput) {
    t5 = {
      activePrCommentInput,
      togglePrCommentInput,
      closePrCommentInput
    };
    $[9] = activePrCommentInput;
    $[10] = closePrCommentInput;
    $[11] = togglePrCommentInput;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}